import { Component, OnInit } from '@angular/core';
import { Book } from '../book';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.css']
})
export class BooksComponent implements OnInit {

  book: Book = {
    uuid : "123e4567-e89b-12d3-a456-426655440000",
    name : "הטיול הקצר, מאת נעמי שמר"
  };

  constructor() {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/shalom/sandbox/kidlendinglibrary/kidlendinglibrary/src/app/books/books.component.ts